import * as Yup from "yup";

const postalCodesOntarioEast = [
  'K0A',
  'K0B',
  'K0C',
  'K0E',
  'K0G',
  'K0H',
  'K0J',
  'K0K',
  'K0L',
  'K0M',
  'K1A',
  'K1B',
  'K1C',
  'K1E',
  'K1G',
  'K1H',
  'K1J',
  'K1K',
  'K1L',
  'K1M',
  'K1N',
  'K1P',
  'K1R',
  'K1S',
  'K1T',
  'K1V',
  'K1W',
  'K1X',
  'K1Y',
  'K1Z',
  'K2A',
  'K2B',
  'K2C',
  'K2E',
  'K2G',
  'K2H',
  'K2J',
  'K2K',
  'K2L',
  'K2M',
  'K2P',
  'K2R',
  'K2S',
  'K2T',
  'K2V',
  'K2W',
  'K4A',
  'K4B',
  'K4C',
  'K4K',
  'K4M',
  'K4P',
  'K4R',
  'K6A',
  'K6H',
  'K6J',
  'K6K',
  'K6T',
  'K6V',
  'K7A',
  'K7C',
  'K7G',
  'K7H',
  'K7K',
  'K7L',
  'K7M',
  'K7N',
  'K7P',
  'K7R',
  'K7S',
  'K7V',
  'K8A',
  'K8B',
  'K8H',
  'K8N',
  'K8P',
  'K8R',
  'K8V',
  'K9A',
  'K9H',
  'K9J',
  'K9K',
  'K9L',
  'K9V',
  'L0A',
  'L0B',
  'L0C',
  'L0E',
  'L0H',
  'L0K',
  'L1A',
  'L1B',
  'L1C',
  'L1E',
  'L1G',
  'L1H',
  'L1J',
  'L1K',
  'L1L',
  'L1M',
  'L1N',
  'L1P',
  'L1R',
  'L1S',
  'L1T',
  'L1V',
  'L1W',
  'L1X',
  'L1Y',
  'L1Z',
]

// List of postal codes for Ontario North East
const postalCodesOntarioNorthEast = [
  'P0A',
  'P0B',
  'P0C',
  'P0E',
  'P0G',
  'P0H',
  'P0J',
  'P0K',
  'P0L',
  'P0M',
  'P0N',
  'P0P',
  'P0R',
  'P0S',
  'P1A',
  'P1B',
  'P1C',
  'P2A',
  'P2B',
  'P2N',
  'P3A',
  'P3B',
  'P3C',
  'P3E',
  'P3G',
  'P3L',
  'P3N',
  'P3P',
  'P3Y',
  'P4N',
  'P4P',
  'P4R',
  'P5A',
  'P5E',
  'P5N',
  'P6A',
  'P6B',
  'P6C',
]

// List of postal codes for Ontario North West
const postalCodesOntarioNorthWest = [
  'P0T',
  'P0V',
  'P0W',
  'P0X',
  'P0Y',
  'P0Z',
  'P7A',
  'P7B',
  'P7C',
  'P7E',
  'P7G',
  'P7J',
  'P7K',
  'P7L',
  'P8N',
  'P8T',
  'P9A',
  'P9N',
]

// add regexp for phone and postal code
export const validationFullFormSchema = Yup.object().shape({
  first_name: Yup.string()
    .required('First Name is required')
    .max(255, 'No more than 255 characters'),
  last_name: Yup.string()
    .required('Last Name is required')
    .max(255, 'No more than 255 characters'),
  date_of_birth: Yup.date()
    .required('Date of Birth is required')
    .test('valid-year', 'Please enter a 4-digit year', function (value) {
      if (value) {
        const year = new Date(value).getFullYear()
        return year.toString().length === 4
      }
      return true // Skip validation if value is not provided
    })
    .max(new Date(), 'Please add correct Date of Birth'),
  gender: Yup.string().required('Gender is required'),
  // gender_identity: Yup.object().shape({
  //   value: Yup.string(),
  //   description: Yup.string(),
  // }),
  appt_exclude_video: Yup.string().required('Opt out of video is required'),
  appt_video_optout_reason: Yup.string(),
  // health_card_number: Yup.string().required("Health Card Number is required"),
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  phone_number: Yup.string()
    .matches(/^\d+$/, 'Phone number should only contain digits')
    .min(10, 'Phone number should be at least 10 digits')
    .required('Phone number is required'),
  street_address: Yup.string()
    .required('Address is required')
    .max(255, 'No more than 255 characters'),
  province: Yup.string()
    .required('Province is required')
    .max(255, 'No more than 255 characters'),
  city: Yup.string()
    .required('City is required')
    .max(255, 'No more than 255 characters'),
  // blood_type: Yup.string().required("Blood Type is required"),
  // apot_symptom_cough: Yup.string().required('Cough is required'),
  appt_respiratory_illness: Yup.string().required(
    'Respiratory illness is required'
  ),
  appt_symptom_fever: Yup.string().required('Fever is required'),
  appt_shortness_of_breath: Yup.string().required(
    'Shortness of breath is required'
  ),
  appt_abdominal_pain: Yup.string().required('Abdominal pain is required'),
  appt_vomiting: Yup.string().required('Vomiting is required'),
  appt_urinary_tract_infection: Yup.string().required(
    'Urinary tract infection is required'
  ),
  appt_rash: Yup.string().required('Rash is required'),
  appt_wound_infection: Yup.string().required('Wound infection is required'),
  appt_trauma_or_injury: Yup.string().required('Trauma or injury is required'),
  appt_earache: Yup.string().required('Earache is required'),
  appt_prescription_refill: Yup.string().required(
    'Prescription refill is required'
  ),
  appt_sick_note: Yup.string().required('Sick note is required'),
  appt_primary_care_needs: Yup.string().required(
    'Primary healthcare needs is required'
  ),
  appt_please_describe_if_answered_yes: Yup.string().when(
    [
      'appt_respiratory_illness',
      'appt_symptom_fever',
      'appt_shortness_of_breath',
      'appt_abdominal_pain',
      'appt_vomiting',
      'appt_urinary_tract_infection',
      'appt_rash',
      'appt_wound_infection',
      'appt_trauma_or_injury',
      'appt_earache',
      'appt_prescription_refill',
      'appt_sick_note',
      'appt_primary_care_needs',
    ],
    (
      appt_respiratory_illness,
      appt_symptom_fever,
      appt_shortness_of_breath,
      appt_abdominal_pain,
      appt_vomiting,
      appt_urinary_tract_infection,
      appt_rash,
      appt_wound_infection,
      appt_trauma_or_injury,
      appt_earache,
      appt_prescription_refill,
      appt_sick_note,
      appt_primary_care_needs
    ) => {
      if (
        appt_respiratory_illness !== 'yes' &&
        appt_symptom_fever !== 'yes' &&
        appt_shortness_of_breath !== 'yes' &&
        appt_primary_care_needs !== 'yes' &&
        appt_abdominal_pain !== 'yes' &&
        appt_vomiting !== 'yes' &&
        appt_urinary_tract_infection !== 'yes' &&
        appt_rash !== 'yes' &&
        appt_wound_infection !== 'yes' &&
        appt_trauma_or_injury !== 'yes' &&
        appt_earache !== 'yes' &&
        appt_prescription_refill !== 'yes' &&
        appt_sick_note !== 'yes' &&
        appt_primary_care_needs !== 'yes'
      ) {
        return
      } else {
        return Yup.string().required('Please enter description')
      }
    }
  ),
  appt_reason_for_medical_visit_today: Yup.string()
    .required('Reason for visit is required')
    .max(255, 'No more than 255 characters'),
  postal_code: Yup.string()
    .required('Postal code is required')
    .matches(
      /^[a-zA-Z][0-9][a-zA-Z][ ]?[0-9][a-zA-Z][0-9]$/,
      'Postal Code format is A1A1A1'
    )
    // Check for Toronto postal codes to provide custom error message
    .test(
      'check-M',
      'Postal code outside of service area (Toronto)',
      (value) => {
        if (value && value[0].toUpperCase() === 'M') {
          return false
        }
        return true
      }
    )
    .test(
      'check-PNE',
      'Postal code outside of service area (Ontario North East)',
      (value) => {
        if (!value) return false
        const prefix = value.replace(/\s/g, '').substring(0, 3).toUpperCase()
        return !postalCodesOntarioNorthEast.includes(prefix)
      }
    )
    // Validate if postal code is in the allowed prefixes
    .test(
      'check-PNW',
      'Postal code outside of service area (Ontario East)',
      (value) => {
        if (!value) return false
        const prefix = value.replace(/\s/g, '').substring(0, 3).toUpperCase()
        return !postalCodesOntarioEast.includes(prefix)
      }
    )
    // Validate if postal code is in the allowed prefixes
    .test('check-prefix', 'Postal code outside of service area', (value) => {
      if (!value) return false
      const prefix = value.replace(/\s/g, '').substring(0, 3).toUpperCase()
      return postalCodesOntarioNorthWest.includes(prefix)
    }),

  // doctor_id: Yup.string().required("Doctor is required"),
  regular_family_doctor: Yup.string().required(
    'Regular Family Doctor is required'
  ),
  medical_problem: Yup.string().required('Medical Problems is required'),
  medications: Yup.string().required('Medications is required'),
  allergies: Yup.string().required('Allergies is required'),
  preferred_pharmacy: Yup.string().required('Preferred Pharmacy is required'),
  doctor_contacted: Yup.string().required(
    'Contacted Family Doctor is required'
  ),
  referred_by_811: Yup.string().required('Referred by 811 is required'),
  preferred_pharmacy_if_yes: Yup.string().max(
    2000,
    'No more than 2000 characters'
  ),
  doctor_contacted_if_yes: Yup.string().max(
    2000,
    'No more than 2000 characters'
  ),
  allergies_if_yes: Yup.string().max(2000, 'No more than 2000 characters'),
  medications_if_yes: Yup.string().max(2000, 'No more than 2000 characters'),
  medical_problem_if_yes: Yup.string().max(
    2000,
    'No more than 2000 characters'
  ),
})
export const validationLongFormSchema = Yup.object().shape({
  first_name: Yup.string()
    .required('First Name is required')
    .max(255, 'No more than 255 characters'),
  last_name: Yup.string()
    .required('Last Name is required')
    .max(255, 'No more than 255 characters'),
  date_of_birth: Yup.date()
    .required('Date of Birth is required')
    .test('valid-year', 'Please enter a 4-digit year', function (value) {
      if (value) {
        const year = new Date(value).getFullYear()
        return year.toString().length === 4
      }
      return true // Skip validation if value is not provided
    })
    .max(new Date(), 'Please add correct Date of Birth'),
  gender: Yup.string().required('Gender is required'),
  // gender_identity: Yup.object().shape({
  //   value: Yup.string(),
  //   description: Yup.string(),
  // }),
  appt_exclude_video: Yup.string().required('Opt out of video is required'),
  appt_video_optout_reason: Yup.string(),
  // health_card_number: Yup.string().required("Health Card Number is required"),
  email: Yup.string(),
  phone_number: Yup.string()
    .matches(/^\d+$/, 'Phone number should only contain digits')
    .min(10, 'Phone number should be at least 10 digits')
    .required('Phone number is required'),
  street_address: Yup.string()
    .required('Address is required')
    .max(255, 'No more than 255 characters'),
  province: Yup.string()
    .required('Province is required')
    .max(255, 'No more than 255 characters'),
  city: Yup.string()
    .required('City is required')
    .max(255, 'No more than 255 characters'),
  // blood_type: Yup.string().required("Blood Type is required"),
  // apot_symptom_cough: Yup.string().required('Cough is required'),
  appt_respiratory_illness: Yup.string().required(
    'Respiratory illness is required'
  ),
  appt_symptom_fever: Yup.string().required('Fever is required'),
  appt_shortness_of_breath: Yup.string().required(
    'Shortness of breath is required'
  ),
  appt_abdominal_pain: Yup.string().required('Abdominal pain is required'),
  appt_vomiting: Yup.string().required('Vomiting is required'),
  appt_urinary_tract_infection: Yup.string().required(
    'Urinary tract infection is required'
  ),
  appt_rash: Yup.string().required('Rash is required'),
  appt_wound_infection: Yup.string().required('Wound infection is required'),
  appt_trauma_or_injury: Yup.string().required('Trauma or injury is required'),
  appt_earache: Yup.string().required('Earache is required'),
  appt_prescription_refill: Yup.string().required(
    'Prescription refill is required'
  ),
  appt_sick_note: Yup.string().required('Sick note is required'),
  appt_primary_care_needs: Yup.string().required(
    'Primary healthcare needs is required'
  ),
  appt_please_describe_if_answered_yes: Yup.string().when(
    [
      'appt_respiratory_illness',
      'appt_symptom_fever',
      'appt_shortness_of_breath',
      'appt_abdominal_pain',
      'appt_vomiting',
      'appt_urinary_tract_infection',
      'appt_rash',
      'appt_wound_infection',
      'appt_trauma_or_injury',
      'appt_earache',
      'appt_prescription_refill',
      'appt_sick_note',
      'appt_primary_care_needs',
    ],
    (
      appt_respiratory_illness,
      appt_symptom_fever,
      appt_shortness_of_breath,
      appt_abdominal_pain,
      appt_vomiting,
      appt_urinary_tract_infection,
      appt_rash,
      appt_wound_infection,
      appt_trauma_or_injury,
      appt_earache,
      appt_prescription_refill,
      appt_sick_note,
      appt_primary_care_needs
    ) => {
      if (
        appt_respiratory_illness !== 'yes' &&
        appt_symptom_fever !== 'yes' &&
        appt_shortness_of_breath !== 'yes' &&
        appt_primary_care_needs !== 'yes' &&
        appt_abdominal_pain !== 'yes' &&
        appt_vomiting !== 'yes' &&
        appt_urinary_tract_infection !== 'yes' &&
        appt_rash !== 'yes' &&
        appt_wound_infection !== 'yes' &&
        appt_trauma_or_injury !== 'yes' &&
        appt_earache !== 'yes' &&
        appt_prescription_refill !== 'yes' &&
        appt_sick_note !== 'yes' &&
        appt_primary_care_needs !== 'yes'
      ) {
        return
      } else {
        return Yup.string().required('Please enter description')
      }
    }
  ),
  appt_reason_for_medical_visit_today: Yup.string()
    .required('Reason for visit is required')
    .max(255, 'No more than 255 characters'),
  postal_code: Yup.string()
    .required('Postal code is required')
    .matches(
      /^[a-zA-Z][0-9][a-zA-Z][ ]?[0-9][a-zA-Z][0-9]$/,
      'Postal Code format is A1A1A1'
    )
    // Check for Toronto postal codes to provide custom error message
    .test(
      'check-M',
      'Postal code outside of service area (Toronto)',
      (value) => {
        if (value && value[0].toUpperCase() === 'M') {
          return false
        }
        return true
      }
    )
    .test(
      'check-PNE',
      'Postal code outside of service area (Ontario North East)',
      (value) => {
        if (!value) return false
        const prefix = value.replace(/\s/g, '').substring(0, 3).toUpperCase()
        return !postalCodesOntarioNorthEast.includes(prefix)
      }
    )
    // Validate if postal code is in the allowed prefixes
    .test(
      'check-PNW',
      'Postal code outside of service area (Ontario East)',
      (value) => {
        if (!value) return false
        const prefix = value.replace(/\s/g, '').substring(0, 3).toUpperCase()
        return !postalCodesOntarioEast.includes(prefix)
      }
    )
    // Validate if postal code is in the allowed prefixes
    .test('check-prefix', 'Postal code outside of service area', (value) => {
      if (!value) return false
      const prefix = value.replace(/\s/g, '').substring(0, 3).toUpperCase()
      return postalCodesOntarioNorthWest.includes(prefix)
    }),
  // doctor_id: Yup.string().required("Doctor is required"),
  regular_family_doctor: Yup.string().required(
    'Regular Family Doctor is required'
  ),
  medical_problem: Yup.string().required('Medical Problems is required'),
  medications: Yup.string().required('Medications is required'),
  allergies: Yup.string().required('Allergies is required'),
  preferred_pharmacy: Yup.string().required('Preferred Pharmacy is required'),
  doctor_contacted: Yup.string().required(
    'Contacted Family Doctor is required'
  ),
  referred_by_811: Yup.string().required('Referred by 811 is required'),
  preferred_pharmacy_if_yes: Yup.string().max(
    2000,
    'No more than 2000 characters'
  ),
  doctor_contacted_if_yes: Yup.string().max(
    2000,
    'No more than 2000 characters'
  ),
  allergies_if_yes: Yup.string().max(2000, 'No more than 2000 characters'),
  medications_if_yes: Yup.string().max(2000, 'No more than 2000 characters'),
  medical_problem_if_yes: Yup.string().max(
    2000,
    'No more than 2000 characters'
  ),
})

export const validationShortFormSchema = Yup.object().shape({
  // email: Yup.string()
  //   .email('Please enter a valid email address')
  //   .required('Email is required'),
  appt_exclude_video: Yup.string().required('Opt out of video is required'),
  appt_video_optout_reason: Yup.string(),
  appt_related_last_visit: Yup.string().required(
    'Related to last visit is required'
  ),
  appt_respiratory_illness: Yup.string().required(
    'Respiratory illness is required'
  ),
  appt_symptom_fever: Yup.string().required('Fever is required'),
  appt_shortness_of_breath: Yup.string().required(
    'Shortness of breath is required'
  ),
  appt_abdominal_pain: Yup.string().required('Abdominal pain is required'),
  appt_vomiting: Yup.string().required('Vomiting is required'),
  appt_urinary_tract_infection: Yup.string().required(
    'Urinary tract infection is required'
  ),
  appt_rash: Yup.string().required('Rash is required'),
  appt_wound_infection: Yup.string().required('Wound infection is required'),
  appt_trauma_or_injury: Yup.string().required('Trauma or injury is required'),
  appt_earache: Yup.string().required('Earache is required'),
  appt_prescription_refill: Yup.string().required(
    'Prescription refill is required'
  ),
  appt_sick_note: Yup.string().required('Sick note is required'),
  appt_primary_care_needs: Yup.string().required(
    'Primary healthcare needs is required'
  ),
  appt_please_describe_if_answered_yes: Yup.string().when(
    [
      'appt_respiratory_illness',
      'appt_symptom_fever',
      'appt_shortness_of_breath',
      'appt_abdominal_pain',
      'appt_vomiting',
      'appt_urinary_tract_infection',
      'appt_rash',
      'appt_wound_infection',
      'appt_trauma_or_injury',
      'appt_earache',
      'appt_prescription_refill',
      'appt_sick_note',
      'appt_primary_care_needs',
    ],
    (
      appt_respiratory_illness,
      appt_symptom_fever,
      appt_shortness_of_breath,
      appt_abdominal_pain,
      appt_vomiting,
      appt_urinary_tract_infection,
      appt_rash,
      appt_wound_infection,
      appt_trauma_or_injury,
      appt_earache,
      appt_prescription_refill,
      appt_sick_note,
      appt_primary_care_needs
    ) => {
      if (
        appt_respiratory_illness !== 'yes' &&
        appt_symptom_fever !== 'yes' &&
        appt_shortness_of_breath !== 'yes' &&
        appt_primary_care_needs !== 'yes' &&
        appt_abdominal_pain !== 'yes' &&
        appt_vomiting !== 'yes' &&
        appt_urinary_tract_infection !== 'yes' &&
        appt_rash !== 'yes' &&
        appt_wound_infection !== 'yes' &&
        appt_trauma_or_injury !== 'yes' &&
        appt_earache !== 'yes' &&
        appt_prescription_refill !== 'yes' &&
        appt_sick_note !== 'yes' &&
        appt_primary_care_needs !== 'yes'
      ) {
        return
      } else {
        return Yup.string().required('Please enter description')
      }
    }
  ),
  // doctor_id: Yup.string().required("Doctor is required"),
  appt_reason_for_medical_visit_today: Yup.string()
    .required('Reason for visit is required')
    .max(255, 'No more than 255 characters'),
})
